export const cnpjMask = (num: string, len: number) => {
  var numberWithZeroes = String(num);
  var counter = numberWithZeroes.length;

  while (counter < len) {
    numberWithZeroes = "0" + numberWithZeroes;

    counter++;
  }

  return numberWithZeroes.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
    "$1.$2.$3/$4-$5",
  );
};

export const addZeroes = (num: string) => {
  var numberWithZeroes = String(num);
  var counter = numberWithZeroes.length;

  while (counter < 2) {
    numberWithZeroes = "0" + numberWithZeroes;

    counter++;
  }

  return numberWithZeroes.replace(/^(\d{2})/, "$1");
};
